module.exports = __webpack_public_path__ + "static/media/search-icon.4e33d8b9.svg";